import * as actionType from "../constants/actionTypes";

const initialState = {
};

const authReducer = (state = initialState, action) => {
  switch (action.type) {
    case actionType.LIST_OF_FAVOURATE_INVENTORY:
      return { ...state, listofinventory: action.data.content, loading: false, error: null };
    case actionType.LIST_OF_ALL_INVENTORY:
      return { ...state, listofallinventory: action.data.content, loading: false, error: null };
    case actionType.LIST_OF_ALL_SERVER_DETAILS:
      return { ...state, listofallfavserver: action.data.data, loading: false, error: null };
    case actionType.LIST_OF_MONITORING_PARAMS:
      return { ...state, listofmonitoringparams: action.data.data, loading: false, error: null };
    case actionType.LIST_OF_INVENTORY_ACCESS_RIGHT:
      return { ...state, listofinventoryaccessright: action.data.data, loading: false, error: null };
    case actionType.ASIGN_INVENTORY_ACCESS_TO_GROUP:
      return { ...state, inventoryaccessright: action.data.data, loading: false, error: null };
    default:
      return state;
  }
};
export default authReducer; 